import {lazy, Suspense} from 'react';
import LoadingPage from '../containers/loading';
const Page = lazy (() => import ('../containers/notMatch'));

function NotMatchRoute () {
  return <Suspense fallback={<LoadingPage />}> <Page /></Suspense>;
}

export default NotMatchRoute;
